enum ECouponValidity {
  ONE_TIME = 'one_time',
  REUSABLE = 'reusable',
}

export default ECouponValidity;
